import type { IconData } from '@stacksjs/iconify-core'

export const notes: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M112 152h288v32H112zm0 88h288v32H112zm0 88h152v32H112z\"/><path fill=\"currentColor\" d=\"M480 48H32v416h448Zm-32 384H64V80h384Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default notes
